/*
 * $Id:: index.js 2021/01/20 04:54 otsolka
 *
 *        . * .
 *      * RRRR  *   Copyright (c) 2012-2021 EUIPO: European Intelectual
 *     .  RR  R  .  Property Organization (trademarks and designs).
 *     *  RRR    *
 *      . RR RR .   ALL RIGHTS RESERVED
 *       *. _ .*
 *
 *  The use and distribution of this software is under the restrictions exposed in 'license.txt'
 */

import React, { useState, useEffect } from 'react';

import IconButton from '@material-ui/core/IconButton';
import Snackbar from '@material-ui/core/Snackbar';
import CloseIcon from '@material-ui/icons/Close';
import Alert from '@material-ui/lab/Alert';
import { useSelector, useDispatch } from 'react-redux';

import { NOTIFICATIONS_SLICE_NAME } from '../../app/constants';
import { notificationsQueue, defaultDuration as defaultDurationSlice } from '../../app/notificationsSlice';
import { ReactComponent as InfoIcon } from '../../assets/images/flag_24px.svg';

const Notification = () => {
    const queue = useSelector(notificationsQueue);
    const defaultDuration = useSelector(defaultDurationSlice);
    const dispatch = useDispatch();

    const [notification, setNotification] = useState(null);

    const removeNotification = () => {
        if (notification) {
            setNotification(null);
            dispatch({ type: `${NOTIFICATIONS_SLICE_NAME}/removeNotification`, payload: notification.key });
        }
    };

    const handleClose = () => {
        removeNotification();
    };

    useEffect(() => {
        if (queue.length) {
            setNotification(queue[0]);
        }
    }, [queue]);

    const handleExited = () => {
        removeNotification();
    };

    const { duration, type, message } = notification || {};

    return (
        <Snackbar
            key={!!notification && notification.id}
            anchorOrigin={{
                vertical: 'top',
                horizontal: 'right',
            }}
            open={!!notification}
            autoHideDuration={duration || defaultDuration}
            onClose={handleClose}
            onExited={handleExited}>
            <Alert
                variant="filled"
                severity={type || 'info'}
                icon={<InfoIcon />}
                action={
                    <IconButton aria-label="close" color="inherit" onClick={handleClose}>
                        <CloseIcon />
                    </IconButton>
                }>
                {message || ''}
            </Alert>
        </Snackbar>
    );
};

export default Notification;
